module.exports = __webpack_public_path__ + "static/tech-stack-b7f7706addbb702b92d1d05463e79ab7.svg";